import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as css from './ModalLimit.scss';

class ModalLimit extends Component {
	close = () => {
		this.props.onCloseModal();
	};

	render() {
		let text = `ניתן לבחור עד  ${this.props.maxLimit}  ${this.props.nameHE} `;

		if (this.props.order === 2 && this.props.maxLimit === '1') {
			text = `ניתן לבצע בחירה אחת`;
		}

		return (
			<div className={classnames(css.modal, { [css.in]: this.props.in })}>
				<div className={css.inner}>
					<p>{text}</p>
					<button className={css.close} type="button" onClick={this.close} />
				</div>
			</div>
		);
	}
}

ModalLimit.propTypes = {
	in: PropTypes.bool.isRequired,
	onCloseModal: PropTypes.func.isRequired,
	nameHE: PropTypes.string.isRequired,
	maxLimit: PropTypes.string.isRequired,
	order: PropTypes.number.isRequired,
};

export default ModalLimit;
